// extracted by mini-css-extract-plugin
export default {"display":"EquationDisplay_display__m3gco","fabContainer":"EquationDisplay_fabContainer__BNXaD"};